import React, { useState } from "react";
import { useRef } from "react/cjs/react.development";

async function getQuestions(token, examId) {
  console.log("Started");
  return fetch(
    "https://project-x-01.herokuapp.com/user/getquestionset/" + examId,
    {
      method: "POST",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    }
  ).then((data) => data.json());
}

function Start({ onQuizStart, token, setQuizData, examId, setExamId }) {
  

  const [loading, setLoading] = useState(false);

  async function loadQuestions() {
    if (token) {
      const qSet = await getQuestions(token, examId);
      console.log(qSet);
      if (qSet) setQuizData(qSet);
      console.log("Started");
    }
    console.log("Clicked" + examId);
    onQuizStart();
  }

  return (
    <div className="card">
      <div className="card-content">
        <div className="content">
          <h1>Start Quiz</h1>
          <p>Good Luck!</p>
          <form>
            <label>
              <p>Exam Id</p>
              <input type="text" onChange={(e) => setExamId(e.target.value)} />
            </label>
          </form>
          <button className="button is-info is-medium" onClick={loadQuestions}>
            Start
          </button>
        </div>
      </div>
    </div>
  );
}

export default Start;
